import React from "react";
// import "../../assets/css/custom-css/labelAndInputField.css";
// import "../../assets/css/custom-css/label.css";
// import "../../assets/css/custom-css/customErrorForFields.css";
import "./CustomLabelDropdown.css";

// import CustomErrorForFields from "./CustomErrorForFields";
import { Select } from "antd";
import { Label } from "recharts";

const { Option } = Select;

export default function CustomLabelDropdown({
  mdValue,
  lgValue,
  smValue,
  xsValue,
  labelText,
  isCompulsary,
  controlId,
  controlName,
  value,
  options = [],
  handleSelectChange,
  errorMessage,
  isDisabled,
  placeholder,
  isRequired,
  wrapperClass,
  mode,
  showSearch = false,
  optionFilterProp,
  filterOption,
  maxTagCount,
  notFoundContent,
  dropdownRender,
  getPopupContainer,
  onChange,
}) {
  return (
    <div className={`custom-field-wrapper ${wrapperClass || ""}`}>
      {/* Label Section */}
      {labelText && (
        <Label
          className={"custom-label"}
          labelText={labelText}
          isCompulsary={isCompulsary}
        />
      )}

      {/* Ant Design Select */}
      <Select
        id={controlId}
        name={controlName}
        value={value || undefined}
        onChange={(val) => {
          if (handleSelectChange) handleSelectChange(val);
          if (onChange) onChange(val);
        }}
        disabled={isDisabled}
        placeholder={placeholder}
        className={`custom-dropdown ${errorMessage ? "error-border" : ""}`}
        size="large"
        allowClear
        optionFilterProp={optionFilterProp || "children"}
        dropdownClassName="custom-options-dropdown"
        getPopupContainer={(trigger) => trigger.parentNode}
        showSearch={showSearch}
        filterOption={filterOption || false}
        mode={mode}
        maxTagCount={maxTagCount}
        notFoundContent={notFoundContent}
        dropdownRender={dropdownRender}
        placement="bottomLeft"
        dropdownAlign={{ points: ["tl", "bl"] }}
      >
        {options.map((opt, index) => (
          <Option key={index} value={opt.value}>
            {opt.label}
          </Option>
        ))}
      </Select>

      {/* Error Message */}
      {/* {errorMessage && <CustomErrorForFields errorMessage={errorMessage} />} */}
    </div>
  );
}
